import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { PwaService } from './services/pwa/pwa.service';
import { NotificationService } from './services/notification/notification.service';
import { CrossDomainSharingService } from './services/cross-domain-sharing.service';
import { AuthenticationService } from './services/authentication/authentication.service';
import { HyperFlowChatbotService } from './services/hyperflow-chatbot/hyperflow-chatbot.service';
import { AttributionService } from './services/attribution/attribution.service';
import { Ga4Service } from './services/ga4/ga4.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'af-notification';

  private sub: Subscription;

  constructor(
    private pwaService: PwaService,
    private notificationService: NotificationService,
    private crossDomainService: CrossDomainSharingService,
    private authService: AuthenticationService,
    private attributionService: AttributionService,
    private ga4Service: Ga4Service,
    private chatbotService: HyperFlowChatbotService,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  ngOnInit(): void {
    // Captura parâmetros de atribuição (utm, campaign, crm_source, channel)
    this.attributionService.captureFromUrl();
    // If attribution contains CRM info, send a crm_interaction once
    const attrib = this.attributionService.getAttribution();
    const sentFlag = sessionStorage.getItem('premiervet_attribution_sent');
    if (attrib && !sentFlag) {
      const channel =
        attrib.channel || attrib.crm_source || attrib.utm_source || 'unknown';
      const campaign =
        attrib.campaign_id || attrib.utm_campaign || attrib.campaign || null;
      const destination = window.location.pathname;
      this.ga4Service.trackCrmInteraction(channel, campaign, destination);
      sessionStorage.setItem('premiervet_attribution_sent', '1');
    }
    this.pwaService.verifyUpdate();
    this.sendMessageCrossDomain();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.ga4Service.emit('page_view', event.urlAfterRedirects);
        const raw = sessionStorage.getItem('premiervet_blog_visit');
        if (raw) {
          const visit = JSON.parse(raw);
          const duration = Date.now() - visit.start;
          let score = 'Baixo';
          if (duration >= 60000) score = 'Alto';
          else if (duration >= 30000) score = 'Médio';
          this.ga4Service.trackViewBlogContent(
            visit.path,
            visit.category,
            score
          );
          sessionStorage.removeItem('premiervet_blog_visit');
        }
      }
    });

    // Subscribing to SubjectBehavior to get user information
    this.sub = this.authService.getUser().subscribe((user) => {
      // Checks if user can acess VET AI and is autenticated within plataform
      if (user && user.hyperFlowChatbotAcess && this.authService.isLoggedIn()) {
        // Generating hyperflow token
        this.authService.getHyperflowToken().subscribe({
          next: (response) => {
            // Initializating chatbot with token
            this.chatbotService.initWithUserToken(response.token);
          }
        });
      }
    });
  }

  ngAfterViewInit(): void {
    setInterval(() => {
      this.pwaService.verifyUpdate();
    }, 900000);
  }

  sendMessageCrossDomain() {
    this.crossDomainService.postCrossDomainMessage();
  }
}
